enum StartCertificationSteps {
  PersonalDataStep = 0,
  ModuleSelectionStep = 1,
  ExamLocationAndDateStep = 2,
  ModulesDetailsStep = 3,
  PaymentAndCompletionStep = 4,
  EmailConfirmationSent = 5,
}

export default StartCertificationSteps;
